import styled from '@emotion/styled';

import { cardAnimation } from '~/src/components/LeanBack/common-components';
import { darkGrey, fontWeight, smokeWhite } from '~/styles';

import { CARD_WIDTH, IMG_ASPECT_RATIO } from './constants';

export const Link = styled.a`
  width: ${CARD_WIDTH}px;
  display: flex;
  flex-direction: column;
  ${cardAnimation};
  cursor: pointer;

  &:hover {
    text-decoration: none;
  }
`;

export const PlayButtonContainer = styled.div`
  position: absolute;
  bottom: 16px;
  right: 16px;
`;

export const ImageContainer = styled.div`
  position: relative;
`;

export const Img = styled.img`
  box-shadow: rgba(0, 0, 0, 0.16) 0px 8px 16px 0px;
  width: 100%;
  aspect-ratio: ${IMG_ASPECT_RATIO};
`;

export const Subtitle = styled.div`
  font-weight: ${fontWeight.medium};
  font-size: 14px;
  display: flex;
  gap: 10px;
`;

export const Title = styled.h2`
  font-weight: ${fontWeight.semiBold};
  letter-spacing: 1px;
  color: ${darkGrey};
  margin: 8px 0 0;
  font-size: 16px;
`;

export const Chip = styled.div`
  position: absolute;
  top: 7px;
  left: -7px;
  padding: 0px 7px;
  color: ${smokeWhite};
  background: ${darkGrey};
  z-index: 1;
`;
